import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

type ContactType = 'email' | 'phone' | 'whatsapp' | 'website' | 'booking' | 'facebook' | 'instagram' | 'linkedin';

interface TrackContactClickParams {
  profileId?: string;
  companyId?: string;
  contactType: ContactType;
}

export const useContactTracking = () => {
  const { user } = useAuth();

  const trackContactClick = async ({ profileId, companyId, contactType }: TrackContactClickParams) => {
    try {
      const { error } = await supabase
        .from('contact_clicks')
        .insert({
          profile_id: profileId || null,
          company_id: companyId || null,
          contact_type: contactType,
          clicked_by_user_id: user?.id || null,
        });

      if (error) {
        console.error('Error tracking contact click:', error);
      }
    } catch (err) {
      console.error('Error tracking contact click:', err);
    }
  };

  return { trackContactClick };
};
